import { createContext } from 'react';

// Context menu context — lets any element trigger the menu without prop drilling
// { open: fn(elId, x, y) }
export const CtxMenuCtx = createContext(null);

// Boolean — true when in preview mode
export const PreviewCtx = createContext(false);

// Drag context — shared mutable drag state accessible at any depth
// { drag: { current }, resetAll: fn, _resets: Set<fn> }
export const DragCtx = createContext(null);

// Page link context — carries allPages/allForms/allLobbies/allSections/eventSlug/etc
// for use by ButtonElement's link picker without prop-drilling
export const PageCtx = createContext({
  allPages: [], allForms: [], allLobbies: [], allSections: [],
  eventSlug: '', eventUrlMode: 'prefixed', currentPageSlug: '',
  loginRedirectHref: null, onLoginRedirectChange: null,
  speakers: [], onSpeakersUpdate: null,
  schedule: [], onScheduleUpdate: null, eventId: null,
  eventBannerUrl: null,
});